import React from 'react';
import { env } from '@admitkard/uiutils/env';
import { Carousel } from '@admitkard/ccl/Carousel';
import { careerCss } from 'components/Career/Career.css';

interface SingleStoryProps {
  storyTeller: string,
  storyContent: string,
  designation: string,
  imgUrl: string,
  linkedinUrl: string,
  index: number
}

const SingleStory: React.FunctionComponent<SingleStoryProps> = (props) => {
  return (
    <>
      <div className='review-slider' key={`${props.index}-card`}>
        <div className='review-card-left'>
          <div className='review-card-left-img'  >
            <img src={env.getAssetUrl(`${props.imgUrl}`)} alt="..." />
          </div>
        </div>
        <div className='review-card-right'>
          <div className='font-f review-card-heading' >
            {`${props.storyTeller}`}
            <a href={`${props.linkedinUrl}`} >
              <img src={env.getAssetUrl('images/career-page/icons/Linkdin_new_(mobile).svg')} alt='linkedin' />
            </a>
          </div>
          <div className='reviews-designation font-f'>
            {`${props.designation}`}
          </div>
          <div className='review-card-content font-f'>
            {props.storyContent}
          </div>
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};

const Stories: React.FunctionComponent = () => {
  return (
    <>
      <div className='news-wrapper'>
        <div className="why-h1 font-f">
        Listen to their stories
        </div>
        <div className='review-carousel-wrapper'>
          <Carousel
            arrows="none"
            dots="outside"
            name="car"
            peek={{
              after: 0,
              before: 0
            }}
            slidePerView={1}
            slides={[
              <SingleStory
                key={1}
                storyTeller='Priyanshi'
                storyContent='I was a complete newbie when I joined this company, worried about whether this is the right decision for me.
                  However, the guidance that I received here freed me from all my doubts.
                  I am glad to invest my time and skills in a company that invests in its employees.'
                designation='UI/UX Intern'
                imgUrl='images/career-page/priyanshi_image_(web).png'
                linkedinUrl='https://www.linkedin.com/in/priyanshisinghwal'
                index={1}
              />,
              <SingleStory
                key={2}
                storyTeller='Charul Kardam'
                storyContent='Working in a company that inspires me, and at the same time challenges me is a non-negotiable for me.
                I am fortunate that I found such an environment at AdmitKard.
                This position has allowed me to stretch beyond my limits and empowers me to do my best every day'
                designation='Growth Manager'
                imgUrl='images/career-page/charul_image_web.png'
                linkedinUrl='https://www.linkedin.com/in/charul-kardam-801445112/'
                index={2}
              />,
              <SingleStory
                key={3}
                storyTeller='Visesh Chogtu'
                storyContent='Being associated with a startup is a tough job. You often feel undervalued but here at AdmitKard,
                people not only understand but also respect differences. The company offers a very comfortable environment
                where talent is always valued.'
                designation='Marketing Head'
                imgUrl='images/career-page/visesh_chogtu_image_(web).png'
                linkedinUrl='https://www.linkedin.com/in/vishesh-chogtu-918456154'
                index={3}
              />,
              <SingleStory
                key={4}
                storyTeller='Isha Vashist'
                storyContent='Working with AdmitKard, I have gained a perfect exposure to the corporate world.
                From fresher to now being an experienced professional, this company has given me
                a sophisticated environment to grow.'
                designation='Process Expert'
                imgUrl='images/career-page/ISHA_VASHIST_IMAGE_(WEB).png'
                linkedinUrl='https://www.linkedin.com/in/isha-vashist-1b2b5a158'
                index={4}
              />,
            ]}
            type="carousel"
          />
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};

export {Stories};
